import { get } from '../../utils/api';

const RETRY_DELAYS_MS = [1000, 3000, 8000];

// Loads the tutor email list used to tell tutors from children in a call. One failed
// request at page load used to leave the list empty for the whole lesson, so this
// retries and rejects on final failure instead of swallowing the error.
export async function loadTutorEmails({
  fetchTutors = () => get('/users/tutors', true),
  delays = RETRY_DELAYS_MS,
  wait = (ms) => new Promise((resolve) => setTimeout(resolve, ms)),
} = {}) {
  let lastError;
  for (let attempt = 0; attempt <= delays.length; attempt += 1) {
    try {
      const tutors = await fetchTutors();
      return tutors.map((tutor) => tutor.email);
    } catch (error) {
      lastError = error;
      if (attempt < delays.length) {
        await wait(delays[attempt]);
      }
    }
  }
  throw lastError;
}
